export const PtIcon = ({ width = '20', height = '20' }: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_33327_6188)">
				<path
					d="M24.6004 20H-5.29942C-5.59428 20 -5.83337 19.7643 -5.83337 19.4737V0.526339C-5.83337 0.235684 -5.59428 0 -5.29942 0H24.6004C24.8953 0 25.1344 0.235684 25.1344 0.526339V19.4737C25.1343 19.7644 24.8952 20 24.6004 20Z"
					fill="#FF4B55"
				/>
				<path
					d="M5.37904 0H-5.29942C-5.59428 0 -5.83337 0.235624 -5.83337 0.526279V19.4736C-5.83337 19.7643 -5.59428 19.9999 -5.29942 19.9999H5.37911V0H5.37904Z"
					fill="#73AF00"
				/>
				<path
					d="M5.38323 14.7331C8.03486 14.7331 10.1844 12.6142 10.1844 10.0003C10.1844 7.38651 8.03486 5.26758 5.38323 5.26758C2.7316 5.26758 0.582031 7.38651 0.582031 10.0003C0.582031 12.6142 2.7316 14.7331 5.38323 14.7331Z"
					fill="#FFE15A"
				/>
				<path
					d="M6.98511 8.42176V10.527C6.98511 11.3977 6.26656 12.106 5.38332 12.106C4.50007 12.106 3.78152 11.3977 3.78152 10.527V8.42176H6.98511ZM7.519 7.36914H3.24757C2.95272 7.36914 2.71362 7.60482 2.71362 7.89548V10.5271C2.71362 11.9804 3.9089 13.1586 5.38326 13.1586C6.85761 13.1586 8.05289 11.9804 8.05289 10.5271V7.89548C8.05295 7.60482 7.81386 7.36914 7.519 7.36914Z"
					fill="#FF4B55"
				/>
				<path
					d="M6.98508 8.42188V10.5271C6.98508 11.3978 6.26653 12.1061 5.38329 12.1061C4.50004 12.1061 3.78149 11.3978 3.78149 10.5271V8.42188H6.98508Z"
					fill="#F5F5F5"
				/>
				<path
					d="M3.24342 8.1572C3.39086 8.1572 3.51039 8.03937 3.51039 7.89403C3.51039 7.74868 3.39086 7.63086 3.24342 7.63086C3.09597 7.63086 2.97644 7.74868 2.97644 7.89403C2.97644 8.03937 3.09597 8.1572 3.24342 8.1572Z"
					fill="#FFE15A"
				/>
				<path
					d="M7.51478 8.1572C7.66222 8.1572 7.78175 8.03937 7.78175 7.89403C7.78175 7.74868 7.66222 7.63086 7.51478 7.63086C7.36733 7.63086 7.2478 7.74868 7.2478 7.89403C7.2478 8.03937 7.36733 8.1572 7.51478 8.1572Z"
					fill="#FFE15A"
				/>
				<path
					d="M3.24342 10.2627C3.39086 10.2627 3.51039 10.1448 3.51039 9.9995C3.51039 9.85415 3.39086 9.73633 3.24342 9.73633C3.09597 9.73633 2.97644 9.85415 2.97644 9.9995C2.97644 10.1448 3.09597 10.2627 3.24342 10.2627Z"
					fill="#FFE15A"
				/>
				<path
					d="M7.51478 10.2627C7.66222 10.2627 7.78175 10.1448 7.78175 9.9995C7.78175 9.85415 7.66222 9.73633 7.51478 9.73633C7.36733 9.73633 7.2478 9.85415 7.2478 9.9995C7.2478 10.1448 7.36733 10.2627 7.51478 10.2627Z"
					fill="#FFE15A"
				/>
				<path
					d="M5.37904 8.1572C5.52648 8.1572 5.64601 8.03937 5.64601 7.89403C5.64601 7.74868 5.52648 7.63086 5.37904 7.63086C5.23159 7.63086 5.11206 7.74868 5.11206 7.89403C5.11206 8.03937 5.23159 8.1572 5.37904 8.1572Z"
					fill="#FFE15A"
				/>
				<path
					d="M6.98194 12.2021C7.12939 12.2021 7.24892 12.0843 7.24892 11.939C7.24892 11.7936 7.12939 11.6758 6.98194 11.6758C6.83449 11.6758 6.71497 11.7936 6.71497 11.939C6.71497 12.0843 6.83449 12.2021 6.98194 12.2021Z"
					fill="#FFE15A"
				/>
				<path
					d="M3.80775 12.2021C3.95519 12.2021 4.07472 12.0843 4.07472 11.939C4.07472 11.7936 3.95519 11.6758 3.80775 11.6758C3.6603 11.6758 3.54077 11.7936 3.54077 11.939C3.54077 12.0843 3.6603 12.2021 3.80775 12.2021Z"
					fill="#FFE15A"
				/>
				<path
					d="M5.72796 9.86719V10.3204C5.72796 10.5079 5.57325 10.6604 5.38309 10.6604C5.19293 10.6604 5.03821 10.5079 5.03821 10.3204V9.86719H5.72796Z"
					fill="#41479B"
				/>
				<path
					d="M5.72796 8.79297V9.24621C5.72796 9.43366 5.57325 9.58617 5.38309 9.58617C5.19293 9.58617 5.03821 9.43366 5.03821 9.24621V8.79297H5.72796Z"
					fill="#41479B"
				/>
				<path
					d="M5.72796 10.9531V11.4064C5.72796 11.5938 5.57325 11.7463 5.38309 11.7463C5.19293 11.7463 5.03821 11.5938 5.03821 11.4064V10.9531H5.72796Z"
					fill="#41479B"
				/>
				<path
					d="M6.6568 9.86719V10.3204C6.6568 10.5079 6.50208 10.6604 6.31192 10.6604C6.12176 10.6604 5.96704 10.5079 5.96704 10.3204V9.86719H6.6568Z"
					fill="#41479B"
				/>
				<path
					d="M4.79925 9.86719V10.3204C4.79925 10.5079 4.64454 10.6604 4.45438 10.6604C4.26421 10.6604 4.1095 10.5079 4.1095 10.3204V9.86719H4.79925Z"
					fill="#41479B"
				/>
			</g>
			<defs>
				<clipPath id="clip0_33327_6188">
					<rect width="20" height="20" rx="10" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
